/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowUpRightSmall: {
  name: 'arrow_up_right_small';
  data: string;
} = {
  name: 'arrow_up_right_small',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="M16 14.122a.75.75 0 1 1-1.5 0V10.31L9.027 15.78a.75.75 0 0 1-1.061-1.06l5.472-5.472H9.625a.75.75 0 1 1 0-1.5h5.624a.75.75 0 0 1 .75.75L16 14.122Z" fill="currentColor"/></svg>`
};
